import type {
  LineAnnotationStyles,
  LineCoordinate,
  Offest,
  PointAnnotationStyles,
  PointCoordinate,
} from '../types';

export const drawLine = (input: {
  context: CanvasRenderingContext2D;
  offset?: Offest;
  coordintate: LineCoordinate;
  styles: LineAnnotationStyles;
  scale?: number;
}) => {
  const {
    context,
    offset = { dx: 0, dy: 0 },
    coordintate,
    styles,
    scale = 1,
  } = input;
  // line
  context.beginPath();
  context.strokeStyle = styles.strokeColor;
  context.lineWidth = styles.strokeWidth;
  context.setLineDash(styles.strokeDashArray);
  context.moveTo(
    coordintate.x1 * scale + offset.dx,
    coordintate.y1 * scale + offset.dy,
  );
  context.lineTo(
    coordintate.x2 * scale + offset.dx,
    coordintate.y2 * scale + offset.dy,
  );
  context.stroke();

  context.setLineDash([]);
  if (styles.showHandles) {
    context.fillStyle = styles.strokeColor;
    context.beginPath();
    context.arc(
      coordintate.x1 * scale + offset.dx,
      coordintate.y1 * scale + offset.dy,
      styles.handleRadius,
      0,
      2 * Math.PI,
    );
    context.fill();
    context.stroke();
    context.beginPath();
    context.arc(
      coordintate.x2 * scale + offset.dx,
      coordintate.y2 * scale + offset.dy,
      styles.handleRadius,
      0,
      2 * Math.PI,
    );
    context.fill();
    context.stroke();
  }
};

export const drawPoint = (input: {
  context: CanvasRenderingContext2D;
  offset?: Offest;
  coordintate: PointCoordinate;
  styles: PointAnnotationStyles;
  scale?: number;
}) => {
  const {
    context,
    offset = { dx: 0, dy: 0 },
    coordintate,
    styles,
    scale = 1,
  } = input;
  context.beginPath();
  context.fillStyle = styles.strokeColor;
  context.arc(
    coordintate.x * scale + offset.dx,
    coordintate.y * scale + offset.dy,
    styles.strokeWidth,
    0,
    2 * Math.PI,
  );
  context.fill();
};
